import axios from 'axios'

// Wajib agar login tidak stuck/berhenti di tempat
axios.defaults.withCredentials = false;
const Api = axios.create({
    // Ini akan otomatis mengambil isi dari file .env Anda
    baseURL: 'https://donasinuruljadid.com/backend-donasi/public/api'
})

export default Api